// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__Pk-yS"};